/**
 * @fileoverview POST handler for the "/integrations/scim/scim_reset_token" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsScimScimResetTokenCacheKeys } from "./constants";
import type { PostIntegrationsScimScimResetTokenProps, IntegrationsScimScimResetTokenResult } from "./types";

export const postIntegrationsScimScimResetToken = reactQueryMutationAdapter(
  integrationsScimScimResetTokenCacheKeys,
  (props: PostIntegrationsScimScimResetTokenProps): Promise<IntegrationsScimScimResetTokenResult> => {
    // manipulate props here as needed idp

    return fetch("/integrations/scim/scim_reset_token", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
